exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bride-js": () => import("./../../../src/pages/bride.js" /* webpackChunkName: "component---src-pages-bride-js" */),
  "component---src-pages-groom-js": () => import("./../../../src/pages/groom.js" /* webpackChunkName: "component---src-pages-groom-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

